module.exports = __webpack_public_path__ + "media/images/emblems/GW-FR-Lully_neu-ef6b7d953cf051eb29c7ac097afdb9c0.png";